/* STEMninja enrolment page (sections/sm-stemninja-enrol.liquid), 18 Oct 2026.
   Three steps in one card and one send at the end, in two parts:
     1. the answers go to the Apps Script web app, which writes one row to the sheet "Enrolments" (never the photo);
     2. once the row is saved, the photo (if one was chosen) goes up in a second message with the same reference.
   So a slow or failed photo upload can never lose an enrolment.
   There is no <form>: every button is type="button" and this file does the sending, so the store's tag manager and Shopify's
   "form submitted" event never see what was typed. Nothing typed ever goes into the page address, the dataLayer, an analytics
   event or localStorage. While the tab is open, a draft of the text answers (never the photo, the agreement tick or the photo
   permission tick) is kept in sessionStorage, so a reload or a trip to another page does not lose them.
   assets/sm-photo.js (the photo box, same file as on the US store) loads before this file. */
(function () {
  'use strict';
  var root = document.getElementById('SmNinjaForm');
  if (!root || !window.Promise) return;
  var section = document.getElementById('SmNinja') || document.body;
  var card = root.parentNode;
  var done = card.querySelector('[data-nj-done]');
  var textEl = card.querySelector('[data-nj-text]');
  var T = textEl ? textEl.dataset : {};
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return [].slice.call((el || root).querySelectorAll(sel)); };
  var GA4 = root.getAttribute('data-ga4') || '';
  var KEY = root.getAttribute('data-sheet-key') || '';
  var DRAFT_KEY = 'sm-ninja-draft-v1';
  var REF_RE = /^NJ-[23456789A-HJKMNP-Z]{8}$/;
  var opened = Date.now();
  var params; try { params = new URLSearchParams(location.search); } catch (e) { params = { get: function () { return null; } }; }

  /* ---- reports: GA4 only (send_to keeps them away from the Google Ads tag on the page), fixed values only, never anything typed ---- */
  var track = function (name, p) {
    try { if (GA4 && typeof window.gtag === 'function') window.gtag('event', name, Object.assign({}, p || {}, { send_to: GA4 })); } catch (e) {}
  };
  var tell = function (key, value, event) {
    try { if (typeof window.clarity === 'function') { if (key) window.clarity('set', key, String(value)); if (event) window.clarity('event', event); } } catch (e) {}
  };
  var ua = navigator.userAgent || '';
  var app = /Instagram/.test(ua) ? 'instagram' : (/FBAN|FBAV/.test(ua) ? 'facebook' : 'none');
  var SRC = ['qr', 'community', 'instagram', 'facebook', 'whatsapp', 'share', 'order', 'certificate', 'pdp'];
  var SRC_SHORT = { ig: 'instagram', fb: 'facebook', wa: 'whatsapp' };   // Instagram tags its own link-in-bio clicks utm_source=ig
  var srcOf = function (v) { v = String(v || '').toLowerCase().trim(); v = SRC_SHORT[v] || v; return v ? (SRC.indexOf(v) >= 0 ? v : 'other') : ''; };
  var gaSrc = srcOf(params.get('src')) || srcOf(params.get('utm_source')) || 'none';

  /* "Came from" for the sheet (column N): only the page address's tags, the referring site and the app, never typed data */
  var cut = function (v) { return String(v || '').toLowerCase().replace(/[^a-z0-9._\/-]/g, '').slice(0, 40); };
  var cameFrom = (function () {
    var parts = [], v;
    if ((v = cut(params.get('src')))) parts.push('src: ' + v);
    var u = [cut(params.get('utm_source')), cut(params.get('utm_medium')), cut(params.get('utm_campaign'))];
    if (u.join('')) parts.push('utm: ' + u.join('/'));
    if ((v = cut(params.get('kit')))) parts.push('kit: ' + v);
    try {
      if (document.referrer) {
        var r = new URL(document.referrer);
        v = cut(r.hostname === location.hostname ? r.hostname + r.pathname : r.hostname);
        if (v) parts.push('ref: ' + v);
      }
    } catch (e) {}
    if (app !== 'none') parts.push('app: ' + app);
    return parts.join(' | ').slice(0, 200);
  })();

  /* ---- elements ---- */
  var steps = {};
  $$('[data-nj-step]').forEach(function (el) { steps[el.getAttribute('data-nj-step')] = el; });
  var title = $('[data-nj-title]'), backBtn = $('[data-nj-back]'), live = $('[data-nj-live]'), bars = $$('.sm-nj__bar i');
  var draftLine = $('[data-nj-draft]');
  var strip = $('[data-nj-strip]'), stripHome = $('[data-nj-strip-home]'), stripDone = done.querySelector('[data-nj-strip-done]');
  var stripName = strip.querySelector('[data-nj-strip-name]'), stripImg = strip.querySelector('[data-nj-strip-img]'), stripFace = strip.querySelector('[data-nj-strip-face]');
  var f = {
    child: $('#SmNinja-child'), d: $('#SmNinja-dob-d'), m: $('#SmNinja-dob-m'), y: $('#SmNinja-dob-y'),
    search: $('#SmNinja-kit-search'), idea: $('#SmNinja-idea'), love: $('#SmNinja-love'), cc: $('#SmNinja-cc'), wa: $('#SmNinja-whatsapp'),
    email: $('#SmNinja-email'), city: $('#SmNinja-city'), agree: $('#SmNinja-agree'), trap: $('[name=sm_nj_code]')
  };
  var genders = $$('input[name=nj_gender]');
  var submitBtn = $('[data-nj-submit]'), waitLine = $('[data-nj-wait]'), errorBox = $('[data-nj-error]');
  /* A signed-in customer's email comes base64-encoded and goes into the box only when step 3 opens: Google's tag on this
     store scans the page for email addresses at load (it hashed the support address in the help line on 18 Oct 2026). */
  var unb64 = function (v) { try { return v ? decodeURIComponent(escape(window.atob(v))) : ''; } catch (e) { return ''; } };
  var prefill = { email: unb64(f.email.getAttribute('data-nj-pf')), city: f.city.defaultValue || '' };
  var held = null, prefillUsed = false;   // held: the number and email of a restored draft, kept out of the page until step 3

  /* ---- state ---- */
  var cur = 1, isDone = false, busy = false, failed = false, ref = '', kits = [], seen = {}, pending = null, ready = false;
  var lastDone = null, photoBusy = false, backTimer, waitTimer, draftTimer;

  var hist = function (method, state) { try { history[method](state, ''); } catch (e) {} };
  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };
  var clean = function (s) { return String(s || '').replace(/\s+/g, ' ').trim(); };
  var childName = function () { return clean(f.child.value).slice(0, 80); };
  /* {Name} on the page: the first word, without a title typed in front ("Master Aarav", "Baby Diya") and with a capital letter.
     Display only: column C keeps the name exactly as typed. */
  var TITLE_RE = /^(master|mstr|baby|miss|ms|kumari|kum|mr)\.?$/i;
  var firstName = function () {
    var w = childName().split(' ');
    while (w.length > 1 && TITLE_RE.test(w[0])) w.shift();
    var n = (w[0] || '').slice(0, 14);
    return n ? n.charAt(0).toUpperCase() + n.slice(1) : '';
  };
  var gender = function () { var g = genders.filter(function (r) { return r.checked; })[0]; return g ? g.value : ''; };

  /* A setting text with {Name}: the child's first name; without one, the setting's own fallback, or "your child". Always plain text. */
  var withName = function (tpl, fb, name) {
    tpl = tpl || '';
    if (name === undefined) name = firstName();
    if (name) return tpl.split('{Name}').join(name);
    if (fb) return fb;
    return tpl.replace(/^\{Name\}/, 'Your child').split('{Name}').join('your child');
  };
  var setTitle = function () {
    title.textContent = (cur === 1 ? T.step1 : (cur === 2 ? withName(T.step2, T.step2Fb) : T.step3)) || '';
  };
  var names = function () {
    var n = firstName();
    $$('[data-nj-tpl]').forEach(function (el) {
      if (busy && el === submitBtn) return;
      el.textContent = withName(el.getAttribute('data-nj-tpl'), el.getAttribute('data-nj-fb'), n);
    });
    var full = childName();
    stripName.textContent = full || stripName.getAttribute('data-placeholder') || '';
    stripName.classList.toggle('is-empty', !full);
    setTitle();
    ageLine();
  };

  /* ---- page position ---- */
  var offset = function () {
    var cs = getComputedStyle(document.documentElement);
    var bar = parseFloat(cs.getPropertyValue('--sm-bar-h')); if (isNaN(bar)) bar = 40;
    var head = parseFloat(cs.getPropertyValue('--sf-header-height')); if (isNaN(head)) head = 58;
    return bar + head + 12;
  };
  var scrollToY = function (y) { window.scrollTo(0, Math.max(0, Math.round(y))); };
  /* Only the window scrolls (never scrollIntoView: on this store it can slide the page sideways). */
  var toCard = function () {
    var box = (isDone ? done : root).getBoundingClientRect(), off = offset();
    if (window.innerWidth < 990 ? Math.abs(box.top - off) > 2 : box.top < off) scrollToY(window.pageYOffset + box.top - off);
  };
  var toEl = function (el) {
    var r = el.getBoundingClientRect(), off = offset();
    if (r.top < off || r.bottom > window.innerHeight) scrollToY(window.pageYOffset + r.top - off);
  };
  var focusQuiet = function (el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } };

  /* ---- steps ---- */
  var show = function (n, quiet) {
    n = Math.min(3, Math.max(1, Number(n) || 1));
    cur = n;
    Object.keys(steps).forEach(function (k) { steps[k].hidden = Number(k) !== n; });
    bars.forEach(function (b, i) { b.classList.toggle('is-on', i < n); });
    backBtn.hidden = n === 1;
    setTitle();
    if (live) live.textContent = 'Step ' + n + ' of 3';
    if (n === 3) fillStep3();
    if (!seen[n]) { seen[n] = true; track('stemninja_step', { step: n }); tell('stemninja_step', String(n)); }
    if (n !== 2) closeList();
    if (!quiet) { focusQuiet(title); toCard(); }
    saveDraftSoon();
  };

  /* ---- field errors ---- */
  var FIELDS = {
    child: { step: 1, el: function () { return f.child; }, all: function () { return [f.child]; } },
    dob: { step: 1, el: function () { return [f.d, f.m, f.y].filter(function (s) { return !s.value; })[0] || f.d; }, all: function () { return [f.d, f.m, f.y]; } },
    gender: { step: 1, el: function () { return genders[0]; }, all: function () { return genders; } },
    kits: { step: 2, el: function () { return f.search; }, all: function () { return [f.search]; } },
    whatsapp: { step: 3, el: function () { return f.wa; }, all: function () { return [f.wa]; } },
    email: { step: 3, el: function () { return f.email; }, all: function () { return [f.email]; } },
    city: { step: 3, el: function () { return f.city; }, all: function () { return [f.city]; } },
    agree: { step: 3, el: function () { return f.agree; }, all: function () { return [f.agree]; } }
  };
  var STEP_FIELDS = { 1: ['child', 'dob', 'gender'], 2: ['kits'], 3: ['whatsapp', 'email', 'city', 'agree'] };
  var errEl = function (k) { return root.querySelector('[data-nj-err="' + k + '"]'); };
  var setErr = function (k, msg) {
    var e = errEl(k); if (!e || !msg) return;
    e.textContent = msg; e.hidden = false;
    FIELDS[k].all().forEach(function (c) {
      c.setAttribute('aria-invalid', 'true');
      var ids = (c.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
      if (ids.indexOf(e.id) < 0) { ids.push(e.id); c.setAttribute('aria-describedby', ids.join(' ')); }
    });
  };
  var clearErr = function (k) {
    var e = errEl(k); if (!e || e.hidden) return;
    e.hidden = true; e.textContent = '';
    FIELDS[k].all().forEach(function (c) {
      c.removeAttribute('aria-invalid');
      var ids = (c.getAttribute('aria-describedby') || '').split(' ').filter(function (id) { return id && id !== e.id; });
      if (ids.length) c.setAttribute('aria-describedby', ids.join(' ')); else c.removeAttribute('aria-describedby');
    });
  };
  var focusField = function (k) {
    var el = FIELDS[k].el(); if (!el) return;
    focusQuiet(el);
    toEl(el.closest('[data-nj-field]') || el);
  };

  /* ---- date of birth ---- */
  var ageEl = $('[data-nj-age]');
  var dob = function () {
    var d = f.d.value, m = f.m.value, y = f.y.value;
    if (!d || !m || !y) return { missing: true };
    var dt = new Date(Number(y), Number(m) - 1, Number(d)), now = new Date();
    if (dt.getFullYear() !== Number(y) || dt.getMonth() !== Number(m) - 1 || dt.getDate() !== Number(d) || dt > now) return { bad: true };
    var age = now.getFullYear() - dt.getFullYear();
    if (now.getMonth() < dt.getMonth() || (now.getMonth() === dt.getMonth() && now.getDate() < dt.getDate())) age--;
    return { ok: true, iso: y + '-' + m + '-' + d, age: age };
  };
  var ageLine = function () {
    var r = dob();
    if (!r.ok) { ageEl.hidden = true; ageEl.textContent = ''; return; }
    var t = withName(T.age || '').split('{n}').join(String(r.age));
    if (r.age === 1) t = t.replace(' years', ' year');
    ageEl.textContent = t; ageEl.hidden = false;
  };
  /* The years from the visitor's own clock (the page may be cached): two years ago back to eighteen years ago, newest first. */
  (function () {
    var now = new Date().getFullYear(), keep = f.y.value, want = [];
    for (var y = now - 2; y >= now - 18; y--) want.push(String(y));
    var have = $$('option', f.y).slice(1).map(function (o) { return o.value; });
    if (have.join() === want.join()) return;
    while (f.y.options.length > 1) f.y.remove(1);
    want.forEach(function (y) { var o = document.createElement('option'); o.value = y; o.textContent = y; f.y.appendChild(o); });
    if (want.indexOf(keep) >= 0) f.y.value = keep;
  })();

  /* ---- WhatsApp number ---- */
  /* Digits typed in an Indian script (Devanagari, Bengali, Gurmukhi, Gujarati, Odia, Tamil, Telugu, Kannada, Malayalam) read as 0-9 */
  var ZEROS = [0x0966, 0x09E6, 0x0A66, 0x0AE6, 0x0B66, 0x0BE6, 0x0C66, 0x0CE6, 0x0D66];
  var asciiDigits = function (s) {
    var out = '';
    for (var i = 0; i < s.length; i++) {
      var c = s.charCodeAt(i), d = -1;
      for (var j = 0; j < ZEROS.length; j++) if (c >= ZEROS[j] && c <= ZEROS[j] + 9) { d = c - ZEROS[j]; break; }
      out += d >= 0 ? String(d) : s.charAt(i);
    }
    return out;
  };
  var CODES = ['971', '966', '974', '968', '965', '973', '977', '91', '44', '65', '61', '1'];   // longest first
  var national = function (cc, d) {
    if (cc === '91') {
      if (d.length === 14 && d.indexOf('0091') === 0) d = d.slice(4);
      else if (d.length === 13 && d.indexOf('910') === 0) d = d.slice(3);   // +91 0 98765 43210
      else if (d.length === 12 && d.indexOf('91') === 0) d = d.slice(2);
      else if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
      if (/^(\d)\1{9}$/.test(d) || d === '1234567890' || d === '0123456789') return { ok: false, msg: T.eWaOther, cc: cc };
      if (d.length !== 10) return { ok: false, msg: T.eWaLen, cc: cc };
      if (!/^[6-9]/.test(d)) return { ok: false, msg: T.eWaFirst, cc: cc };
      return { ok: true, cc: '91', value: d, show: '+91 ' + d.slice(0, 5) + ' ' + d.slice(5), box: d.slice(0, 5) + ' ' + d.slice(5) };
    }
    if (cc === '1') {
      if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
      return d.length === 10 ? { ok: true, cc: '1', value: '+1' + d, show: '+1 ' + d, box: d } : { ok: false, msg: T.eWaOther, cc: cc };
    }
    if (d.charAt(0) === '0') d = d.slice(1);   // a national leading 0 is dropped
    return d.length >= 6 && d.length <= 12 && cc.length + d.length <= 15
      ? { ok: true, cc: cc, value: '+' + cc + d, show: '+' + cc + ' ' + d, box: d }
      : { ok: false, msg: T.eWaOther, cc: cc };
  };
  var parsePhone = function (raw, cc) {
    var s = String(raw || '');
    try { s = s.normalize('NFKC'); } catch (e) {}
    s = asciiDigits(s);
    var d = s.replace(/\D/g, ''), intl = null;
    if (!d) return { ok: false, empty: true, msg: cc === '91' ? T.eWaLen : T.eWaOther };
    /* two numbers: 16 or more digits, or digits on both sides of a comma, slash, "or" and the like (the box takes 24 characters) */
    if (d.length >= 16 || /\d[\s.-]*[,\/;&|][\s.-]*\+?\d/.test(s) || /\d\s+(or|and)\s+\+?\d/i.test(s)) return { ok: false, msg: T.eWaTwo };
    if (/^[^0-9+]*\+/.test(s)) intl = d;                                        // typed or pasted with +code
    else if (/^[^0-9]*00[1-9]/.test(s) && d.length > 11) intl = d.slice(2);     // 00code
    else if (cc === 'other') intl = d;
    if (intl !== null) {
      var code = '';
      for (var i = 0; i < CODES.length; i++) if (intl.indexOf(CODES[i]) === 0) { code = CODES[i]; break; }
      if (!code) return intl.length >= 8 && intl.length <= 15 ? { ok: true, cc: 'other', value: '+' + intl, show: '+' + intl, box: '+' + intl } : { ok: false, msg: T.eWaOther, cc: 'other' };
      return national(code, intl.slice(code.length));
    }
    return national(cc, d);
  };
  var tzCode = function () {
    var tz = ''; try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
    if (/^America\//.test(tz)) return '1';
    if (/^Australia\//.test(tz)) return '61';
    return { 'Asia/Dubai': '971', 'Europe/London': '44', 'Asia/Singapore': '65', 'Asia/Riyadh': '966', 'Asia/Qatar': '974', 'Asia/Muscat': '968',
      'Asia/Kuwait': '965', 'Asia/Bahrain': '973', 'Asia/Kathmandu': '977', 'Asia/Katmandu': '977' }[tz] || '91';
  };
  var ccFace = $('[data-nj-cc-face]'), waOk = $('[data-nj-wa-ok]');
  var setCc = function (v) {
    if ([].some.call(f.cc.options, function (o) { return o.value === v; })) f.cc.value = v;
    ccFace.textContent = (f.cc.value === 'other' ? 'Other' : '+' + f.cc.value) + ' ';
    var arrow = document.createElement('span'); arrow.className = 'sm-nj__cc-arrow'; ccFace.appendChild(arrow);
    f.wa.placeholder = f.cc.value === 'other' ? '+code number' : '98765 43210';
  };
  /* US email box (owner, 31 Oct 2026): shown only while the number is a +1 number (USA/Canada chosen, or a +1 number typed);
     optional, never ticked in advance, unticked whenever it hides, never kept in the draft or the tab's note. */
  var usBox = $('[data-nj-usmail]'), usIn = usBox ? usBox.querySelector('input[type=checkbox]') : null;
  var isUsNumber = function (p) { return !!(p && p.ok && /^\+1\d{10}$/.test(p.value)); };
  var updateUs = function (p) {
    if (!usBox || !usIn) return;
    var on = f.cc.value === '1' || isUsNumber(p);
    if (usBox.hidden === on) usBox.hidden = !on;
    if (!on) usIn.checked = false;
  };
  var phoneOk = function () {
    var p = parsePhone(f.wa.value, f.cc.value);
    if (p.ok) { waOk.textContent = (T.waOk || '').split('{number}').join(p.show); waOk.hidden = false; }
    else { waOk.hidden = true; waOk.textContent = ''; }
    updateUs(p);
    return p;
  };
  /* After a paste and when the box is left: a +code different from the chosen one switches the country; on leaving, the
     number is also written plainly (98765 43210). Never while typing. */
  var applyPhone = function (format) {
    var p = parsePhone(f.wa.value, f.cc.value);
    if (!p.ok) return p;
    if (p.cc !== f.cc.value) setCc(p.cc);
    if (format) f.wa.value = p.box;
    phoneOk();
    return p;
  };

  /* ---- email ---- */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var FIX = {
    'gmial.com': 'gmail.com', 'gamil.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gmal.com': 'gmail.com', 'gnail.com': 'gmail.com',
    'gmaill.com': 'gmail.com', 'gmail.co': 'gmail.com', 'gmail.con': 'gmail.com', 'gmail.cm': 'gmail.com', 'gmail.om': 'gmail.com',
    'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yahoo.con': 'yahoo.com',
    'hotmial.com': 'hotmail.com', 'hotmal.com': 'hotmail.com', 'hotmail.con': 'hotmail.com',
    'outlok.com': 'outlook.com', 'outloo.com': 'outlook.com',
    'redifmail.com': 'rediffmail.com', 'rediffmail.con': 'rediffmail.com',
    'icloud.con': 'icloud.com'
  };
  var domainsBox = $('[data-nj-domains]'), domainBtns = $$('[data-domain]', domainsBox);
  var typoBox = $('[data-nj-typo]'), typoText = $('[data-nj-typo-text]'), typoFix = $('[data-nj-typo-fix]'), typoTo = '';
  var emailChips = function () {
    var v = f.email.value, at = v.indexOf('@');
    var on = document.activeElement === f.email && at > 0 && v.indexOf('@', at + 1) < 0 && v.indexOf('.', at) < 0;
    var tail = on ? v.slice(at + 1).toLowerCase() : '', any = false;
    domainBtns.forEach(function (b) { var ok = on && b.getAttribute('data-domain').indexOf(tail) === 0; b.hidden = !ok; if (ok) any = true; });
    domainsBox.hidden = !any;
  };
  var typo = function () {
    var v = f.email.value.trim(), at = v.lastIndexOf('@');
    var fix = at > 0 ? FIX[v.slice(at + 1).toLowerCase()] : '';
    if (!fix) { typoBox.hidden = true; typoTo = ''; return; }
    typoTo = v.slice(0, at + 1) + fix;
    typoText.textContent = (T.typo || '').split('{fixed}').join(typoTo);
    typoBox.hidden = false;
  };

  /* ---- kits ---- */
  var norm = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); };
  var words = function (s) { return String(s || '').toLowerCase().split(/[^a-z0-9]+/).filter(Boolean); };
  var catalogue = [], byHandle = {};
  var chips = $$('.sm-nj__chip');
  var addToCat = function (el) {
    var h = el.getAttribute('data-handle'), n = clean(el.getAttribute('data-name'));
    if (!h || !n || byHandle[h]) return;
    byHandle[h] = { h: h, n: n, img: el.getAttribute('data-img') || '', key: norm(n), words: words(n) };
    catalogue.push(byHandle[h]);
  };
  $$('[data-nj-all] li').forEach(addToCat);
  chips.forEach(addToCat);
  /* Spellings read as another word before matching */
  var SPELL = { hydrolic: 'hydraulic', hydralic: 'hydraulic', hydrualic: 'hydraulic', aeroplane: 'airplane', aeroplanes: 'airplanes' };
  /* Words parents use for a kit whose name says something else. A phrase counts only when it is the whole search
     (or the start of a word still being typed), so "robot car" does not turn into the racing car. */
  var ALIASES = [
    [['airplane'], ['hydraulic-plane-launcher', 'airplanes-launchers']], [['aeroplane'], ['hydraulic-plane-launcher', 'airplanes-launchers']],
    [['plane'], ['hydraulic-plane-launcher', 'airplanes-launchers']],
    [['human', 'body'], ['interactive-human-body', 'human-body-puzzle']],
    [['science', 'kit'], ['my-first-science-kit', 'amazing-science-lab', 'magic-of-science', 'glow-chemistry-science-kit', 'mega-crystal-earth-science-kit']],
    [['hand'], ['smartivity-mechanical-hand']], [['spin'], ['multi-builds-spin-n-go-kit']], [['globe'], ['globe-trotter-ar-enabled']],
    [['marble'], ['ultimate-marble-city', 'logix-marblz']], [['crane'], ['hydraulic-crane']], [['lamp'], ['table-lamp']],
    [['pirate'], ['pirates-telescope']], [['telescope'], ['pirates-telescope']], [['microscope'], ['smartivity-microscope']],
    [['speedster'], ['smartivity-stemwheels-speedster']], [['car'], ['smartivity-stemwheels-speedster']]
  ];
  var chosenHas = function (h) { return kits.some(function (k) { return k.h === h; }); };
  /* Kits for what was typed, best first. rank: 0 the exact name, 1 a word parents use for it, 2 the name starts with it,
     3 every typed word starts a word of the name, 4 every typed word is inside a word of the name (never across two words:
     "car" must not find "Robotic Arm"), 5 a word for a kit that covers only part of what was typed (a suggestion, never
     picked by Enter). full = the kit matches everything typed. */
  var findKits = function (raw) {
    var qw = words(raw).map(function (w) { return SPELL[w] || w; }), q = qw.join(''), found = {};
    if (!q) return [];
    var put = function (k, rank) {
      if (!k || chosenHas(k.h)) return;
      if (!found[k.h] || found[k.h].rank > rank) found[k.h] = { kit: k, rank: rank, full: rank < 5 };
    };
    catalogue.forEach(function (k) {
      if (k.key === q) return put(k, 0);
      if (k.key.indexOf(q) === 0) return put(k, 2);
      if (qw.every(function (w) { return k.words.some(function (x) { return x.indexOf(w) === 0; }); })) return put(k, 3);
      if (qw.every(function (w) { return k.words.some(function (x) { return x.indexOf(w) >= 0; }); })) put(k, 4);
    });
    ALIASES.forEach(function (a) {
      var ph = a[0], whole = qw.length === ph.length && ph.every(function (w, i) {
        return qw[i] === w || (i === ph.length - 1 && qw[i].length >= 3 && w.indexOf(qw[i]) === 0);
      });
      var part = !whole && qw.some(function (w, i) { return ph.every(function (p, j) { return qw[i + j] === p; }); });
      if (whole || part) a[1].forEach(function (h) { put(byHandle[h], whole ? 1 : 5); });
    });
    var order = {}; catalogue.forEach(function (k, i) { order[k.h] = i; });
    return Object.keys(found).map(function (h) { return found[h]; })
      .sort(function (a, b) { return a.rank - b.rank || order[a.kit.h] - order[b.kit.h]; }).slice(0, 6);
  };
  /* The value for the sheet: the kits from the list first, then names typed by the parent */
  var kitValue = function (list) {
    list = list || kits;
    return list.filter(function (k) { return k.h; }).map(function (k) { return k.n; })
      .concat(list.filter(function (k) { return !k.h; }).map(function (k) { return k.n; })).join(', ');
  };
  var kitNote = $('[data-nj-kit-note]'), kitLive = $('[data-nj-kit-live]');
  var chosenBox = $('[data-nj-chosen]'), chosenList = $('[data-nj-chosen-list]');
  var addKit = function (k) {
    if (!k || !k.n) return false;
    if (k.h ? chosenHas(k.h) : kits.some(function (x) { return !x.h && x.n.toLowerCase() === k.n.toLowerCase(); })) return true;
    var next = kits.concat([{ h: k.h || '', n: k.n }]);
    if (next.length > 10 || kitValue(next).length > 300) { kitNote.textContent = T.kitLimit || ''; kitNote.hidden = false; return false; }
    kits = next; kitNote.hidden = true;
    renderKits(true);
    kitLive.textContent = (T.added || 'Added') + ': ' + k.n;
    return true;
  };
  var renderKits = function (edited) {
    chips.forEach(function (c) { c.setAttribute('aria-pressed', chosenHas(c.getAttribute('data-handle')) ? 'true' : 'false'); });
    chosenList.textContent = '';
    kits.forEach(function (k, i) {
      var li = document.createElement('li'); li.className = 'sm-tab sm-nj__kit';
      var s = document.createElement('span'); s.textContent = k.n; li.appendChild(s);
      var b = document.createElement('button'); b.type = 'button'; b.className = 'sm-nj__x';
      b.setAttribute('aria-label', (T.remove || 'Remove') + ' ' + k.n);
      b.textContent = String.fromCharCode(215);
      b.addEventListener('click', function () { kits.splice(i, 1); kitNote.hidden = true; renderKits(true); focusQuiet(f.search); });
      li.appendChild(b); chosenList.appendChild(li);
    });
    chosenBox.hidden = !kits.length;
    if (kits.length) clearErr('kits');
    if (edited) { changed(); saveDraftSoon(); }
  };
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      var h = c.getAttribute('data-handle');
      if (chosenHas(h)) { kits = kits.filter(function (k) { return k.h !== h; }); kitNote.hidden = true; renderKits(true); }
      else addKit(byHandle[h]);
    });
  });

  /* The search box is a combobox: up to 6 kits from the list, then 'Add "what was typed"'. */
  var list = $('#SmNinja-kit-list'), opts = [], active = -1, pinned = false;
  var closeList = function () {
    active = -1; opts = []; pinned = false;
    if (!list) return;
    list.hidden = true; list.textContent = '';
    f.search.setAttribute('aria-expanded', 'false'); f.search.removeAttribute('aria-activedescendant');
  };
  var renderList = function () {
    var raw = f.search.value, typed = clean(raw).slice(0, 60);
    opts = findKits(raw);
    var exact = opts.some(function (o) { return o.rank === 0; });
    var dupe = kits.some(function (k) { return !k.h && k.n.toLowerCase() === typed.toLowerCase(); });
    if (typed.length >= 2 && !exact && !dupe) opts.push({ typed: typed });
    if (active >= opts.length) active = opts.length - 1;
    list.textContent = '';
    opts.forEach(function (o, i) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option'); li.id = 'SmNinja-opt-' + i;
      li.className = 'sm-nj__opt' + (o.typed ? ' is-add' : '') + (i === active ? ' is-active' : '');
      li.setAttribute('aria-selected', i === active ? 'true' : 'false');
      if (o.kit) {
        if (o.kit.img) { var im = document.createElement('img'); im.src = o.kit.img; im.alt = ''; im.width = 40; im.height = 40; im.loading = 'lazy'; li.appendChild(im); }
        else { var ph = document.createElement('span'); ph.className = 'sm-nj__noimg'; li.appendChild(ph); }
      }
      var sp = document.createElement('span');
      sp.textContent = o.kit ? o.kit.n : (T.add || 'Add "{typed}"').split('{typed}').join(o.typed);
      li.appendChild(sp);
      li.addEventListener('mousedown', function (e) { e.preventDefault(); });   // keep the focus where it is
      li.addEventListener('click', function () { pick(i); });
      list.appendChild(li);
    });
    var open = opts.length > 0;
    list.hidden = !open;
    f.search.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (active >= 0) f.search.setAttribute('aria-activedescendant', 'SmNinja-opt-' + active); else f.search.removeAttribute('aria-activedescendant');
  };
  var pick = function (i) {
    var o = opts[i]; if (!o) return;
    var wasPinned = pinned;
    var ok = o.kit ? addKit(o.kit) : addKit({ h: '', n: o.typed });
    if (ok) { f.search.value = ''; closeList(); }
    /* After a tap in the list that Next left open, the keyboard stays closed (focusing the box would open it again) */
    if (!wasPinned || document.activeElement === f.search) focusQuiet(f.search);
  };
  /* What typed text that was not picked stands for: the exact kit, the one kit that matches everything typed, or (when
     no kit matches everything) the typed text itself. Several kits that match: 'choose', the parent taps the right one. */
  var decide = function () {
    var kitOpts = opts.filter(function (o) { return o.kit; });
    var exact = kitOpts.filter(function (o) { return o.rank === 0; })[0];
    if (exact) return opts.indexOf(exact);
    var full = kitOpts.filter(function (o) { return o.full; });
    if (full.length === 1) return opts.indexOf(full[0]);
    if (full.length > 1) return 'choose';
    for (var j = 0; j < opts.length; j++) if (opts[j].typed) return j;
    return 'choose';
  };
  /* Next on step 2 with text still in the search box: take it as Enter would, so a typed kit is never lost or refused.
     Answers false when the parent has to choose between several kits first (the list stays open). */
  var takeTyped = function () {
    if (clean(f.search.value).length < 2) return true;
    active = -1; renderList();
    var d = decide();
    if (d === 'choose') {
      pinned = true;
      kitLive.textContent = T.eKitsPick ? T.eKitsPick.split('{typed}').join(clean(f.search.value).slice(0, 60)) : '';
      return false;
    }
    pick(d);
    return true;
  };
  f.search.addEventListener('input', function () { active = -1; pinned = false; clearErr('kits'); renderList(); });
  f.search.addEventListener('focus', function () {
    pinned = false;
    if (clean(f.search.value)) renderList();
    /* Phones: move the box near the top of the screen, so the list under it is not hidden by the keyboard */
    if (window.innerWidth < 768) setTimeout(function () {
      if (document.activeElement !== f.search) return;
      var r = f.search.getBoundingClientRect(), off = offset();
      if (Math.abs(r.top - off) > 8) scrollToY(window.pageYOffset + r.top - off);
    }, 300);
  });
  f.search.addEventListener('blur', function () { setTimeout(function () { if (document.activeElement !== f.search && !pinned) closeList(); }, 150); });
  f.search.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!opts.length) renderList();
      if (!opts.length) return;
      e.preventDefault();
      active = e.key === 'ArrowDown' ? (active + 1) % opts.length : (active <= 0 ? opts.length - 1 : active - 1);
      renderList();
    } else if (e.key === 'Escape') {
      if (!list.hidden) { e.preventDefault(); closeList(); }
    } else if (e.key === 'Enter' && !e.isComposing && e.keyCode !== 229) {
      /* Enter: the option chosen with the arrow keys; otherwise the exact kit, the one kit that matches, or the typed text
         when no kit matches. With several matching kits nothing is added and the list stays open. */
      e.preventDefault(); e.stopPropagation();
      if (!clean(f.search.value)) { next(); return; }
      if (!opts.length) renderList();
      if (active >= 0 && opts[active]) { pick(active); return; }
      var d = decide();
      if (d === 'choose') { renderList(); kitLive.textContent = T.kitsMany || ''; }
      else pick(d);
    }
  });

  /* ---- photo (assets/sm-photo.js), one box in step 2 and one on the thank-you ---- */
  var photoWrap = $('[data-nj-photo]'), laterWrap = done.querySelector('[data-nj-photo-later]');
  var photoText = { tooLarge: T.photoBig, unreadable: T.photoBad };
  var picker = window.SmPhotoPicker && photoWrap ? window.SmPhotoPicker(photoWrap, photoText) : null;
  var picker2 = window.SmPhotoPicker && laterWrap ? window.SmPhotoPicker(laterWrap, photoText) : null;
  if (!picker && photoWrap) photoWrap.hidden = true;   // the photo script did not load: no box that cannot take a photo
  var stripPhoto = function (p) {
    if (p && p.data) { stripImg.src = 'data:image/jpeg;base64,' + p.data; stripImg.hidden = false; stripFace.style.display = 'none'; }
    else { stripImg.removeAttribute('src'); stripImg.hidden = true; stripFace.style.display = ''; }
  };
  var watchPhoto = function (wrap, pk, accepted) {
    if (!wrap || !pk) return;
    wrap.addEventListener('sm-photo-accepted', function () {
      var nm = wrap.querySelector('[data-sm-photo-name]'); if (nm && T.photoAdded) nm.textContent = T.photoAdded;
      stripPhoto(pk.get());
      if (accepted) accepted(pk.get());
    });
    wrap.addEventListener('sm-photo-refused', function () { stripPhoto(null); });
    var rm = wrap.querySelector('[data-sm-photo-remove]');
    if (rm) rm.addEventListener('click', function () { setTimeout(function () { if (!pk.get()) stripPhoto(null); }, 0); });
    pk.input.addEventListener('change', function () { if (!pk.get()) stripPhoto(null); });
  };
  /* Photo permission (owner, 31 Oct 2026): optional and never pre-ticked. In step 2 the box shows only once a photo is chosen
     (removing the photo hides and unticks it); on the thank-you it sits above "Add a photo", because a photo added there goes
     up at once. Its state goes with the photo message only, never into the draft or the tab's note. */
  var consentWrap = photoWrap ? photoWrap.querySelector('[data-nj-consent]') : null;
  var consentIn = consentWrap ? consentWrap.querySelector('input[type=checkbox]') : null;
  var consentLater = laterWrap ? laterWrap.querySelector('.sm-nj__consent input[type=checkbox]') : null;
  var consentOf = function (inp) {
    var t = inp && inp.parentNode ? inp.parentNode.querySelector('[data-nj-consent-text]') : null;
    return { yes: !!(inp && inp.checked), text: t ? t.textContent.replace(/\s+/g, ' ').trim().slice(0, 500) : '' };
  };
  var showConsent = function () {
    if (!consentWrap || !consentIn) return;
    var has = !!(picker && picker.get());
    consentWrap.hidden = !has;
    if (!has) consentIn.checked = false;
  };
  var resetConsent = function () {
    if (consentIn) consentIn.checked = false;
    if (consentLater) consentLater.checked = false;
    showConsent();
  };
  if (photoWrap && picker) {
    ['sm-photo-accepted', 'sm-photo-refused'].forEach(function (ev) { photoWrap.addEventListener(ev, showConsent); });
    var rm1 = photoWrap.querySelector('[data-sm-photo-remove]');
    if (rm1) rm1.addEventListener('click', function () { setTimeout(showConsent, 0); });
    picker.input.addEventListener('change', function () { setTimeout(showConsent, 0); });
  }
  watchPhoto(photoWrap, picker);
  watchPhoto(laterWrap, picker2, function (p) { if (p && isDone && lastDone) startPhoto(p.data, 'added_later', consentOf(consentLater)); });

  /* ---- toy idea ---- */
  var ideaBtn = $('[data-nj-idea-btn]'), ideaBox = $('[data-nj-idea-box]');
  var grow = function () { f.idea.style.height = 'auto'; f.idea.style.height = Math.min(f.idea.scrollHeight + 3, 260) + 'px'; };
  var openIdea = function (focus) {
    ideaBox.hidden = false; ideaBtn.setAttribute('aria-expanded', 'true'); ideaBtn.hidden = true;
    grow(); if (focus) focusQuiet(f.idea);
  };
  var closeIdea = function () { f.idea.style.height = ''; }; /* the idea box stays open: it is meant to be seen */
  ideaBtn.addEventListener('click', function () { openIdea(true); });
  f.idea.addEventListener('input', grow);

  /* ---- why they love Smartivity (optional, may be switched off in the editor, so f.love can be missing) ---- */
  var LOVE_MAX = 300;
  var loveVal = function () { return f.love ? f.love.value.replace(/\s+/g, ' ').trim().slice(0, LOVE_MAX) : ''; };
  var loveSet = function (v) { if (f.love) { f.love.value = v; f.love.style.height = ''; } };
  if (f.love) f.love.addEventListener('input', function () { f.love.style.height = 'auto'; f.love.style.height = Math.min(f.love.scrollHeight + 3, 200) + 'px'; });

  /* ---- draft (this tab only, text only) ---- */
  var store = {
    get: function () { try { return JSON.parse(window.sessionStorage.getItem(DRAFT_KEY) || 'null'); } catch (e) { return null; } },
    set: function (v) { try { window.sessionStorage.setItem(DRAFT_KEY, JSON.stringify(v)); } catch (e) {} },
    clear: function () { try { window.sessionStorage.removeItem(DRAFT_KEY); } catch (e) {} }
  };
  /* After a send, a small note of it (reference, first name, child's name, number shown, photo saved or not, and the
     parent's answers that "Enrol a brother or sister" keeps) so that a reload or a return from WhatsApp shows the
     thank-you again, with "Add a photo", instead of an empty form. This tab only, like the draft it replaces. */
  var DONE_KEY = 'sm-ninja-done-v1';
  var doneStore = {
    get: function () { try { return JSON.parse(window.sessionStorage.getItem(DONE_KEY) || 'null'); } catch (e) { return null; } },
    set: function (v) { try { window.sessionStorage.setItem(DONE_KEY, JSON.stringify(v)); } catch (e) {} },
    clear: function () { try { window.sessionStorage.removeItem(DONE_KEY); } catch (e) {} }
  };
  var saveDraft = function () {
    clearTimeout(draftTimer);
    if (!ready || isDone) return;
    store.set({
      step: cur, child: f.child.value, dob_d: f.d.value, dob_m: f.m.value, dob_y: f.y.value, gender: gender(),
      kits: kits.map(function (k) { return { h: k.h, n: k.n }; }), idea: f.idea.value, love: f.love ? f.love.value : '', cc: f.cc.value,
      whatsapp: held ? held.wa : f.wa.value, email: held ? held.email : f.email.value, city: f.city.value, ref: ref
    });
  };
  /* Step 3 opens: the held number and email of a restored draft, or a signed-in customer's email, go into their boxes */
  function fillStep3() {
    if (held) {
      if (held.wa && !f.wa.value) f.wa.value = held.wa;
      if (held.email && !f.email.value) { f.email.value = held.email; prefillUsed = true; }
      held = null;
      phoneOk();
    }
    if (!prefillUsed && !f.email.value && prefill.email) f.email.value = prefill.email;
    prefillUsed = true;
  }
  function saveDraftSoon() { if (!ready) return; clearTimeout(draftTimer); draftTimer = setTimeout(saveDraft, 400); }
  var has = function (sel, v) { return [].some.call(sel.options, function (o) { return o.value === v; }); };
  var str = function (v, max) { return typeof v === 'string' ? v.slice(0, max) : ''; };
  var restore = function (dr) {
    f.child.value = str(dr.child, 80);
    [['d', 'dob_d'], ['m', 'dob_m'], ['y', 'dob_y']].forEach(function (p) { var v = str(dr[p[1]], 4); f[p[0]].value = has(f[p[0]], v) ? v : ''; });
    genders.forEach(function (r) { r.checked = r.value === dr.gender; });
    kits = (Array.isArray(dr.kits) ? dr.kits : []).map(function (k) {
      if (!k || typeof k !== 'object') return null;
      if (k.h && byHandle[k.h]) return { h: k.h, n: byHandle[k.h].n };
      var n = clean(str(k.n, 60));
      return n ? { h: '', n: n } : null;
    }).filter(Boolean).slice(0, 10);
    f.idea.value = str(dr.idea, 1000);
    if (f.idea.value) openIdea(false);
    loveSet(str(dr.love, LOVE_MAX));
    if (typeof dr.cc === 'string' && has(f.cc, dr.cc)) setCc(dr.cc);
    held = { wa: str(dr.whatsapp, 24), email: typeof dr.email === 'string' ? dr.email.slice(0, 120) : '' };
    if (typeof dr.city === 'string') f.city.value = dr.city.slice(0, 40);
    ref = typeof dr.ref === 'string' && REF_RE.test(dr.ref) ? dr.ref : '';
    failed = !!ref;   // a reference without a thank-you: an earlier try did not finish
  };
  var meaningful = function (dr) {
    return !!(dr && (dr.child || dr.dob_d || dr.dob_m || dr.dob_y || dr.gender || (dr.kits && dr.kits.length) || dr.idea || dr.love || dr.whatsapp));
  };

  /* After a failed try, a changed answer means a corrected entry: it gets a new reference (the team sees it as a repeat). */
  function changed() { if (failed && !busy) { failed = false; ref = ''; } }
  root.addEventListener('input', function (e) { if (e.target !== f.search && e.target.type !== 'file' && e.target !== f.trap) { changed(); saveDraftSoon(); } });
  root.addEventListener('change', function (e) { if (e.target !== f.search && e.target.type !== 'file' && e.target !== f.trap) { changed(); saveDraftSoon(); } });

  /* ---- field events ---- */
  var twoNote = $('[data-nj-two]'), cityNote = $('[data-nj-city-note]');
  var checkTwo = function () { twoNote.hidden = !/\sand\s|&|,|\//i.test(childName()); };
  f.child.addEventListener('input', function () { clearErr('child'); names(); if (!twoNote.hidden) checkTwo(); });
  f.child.addEventListener('blur', function () { if (childName()) checkTwo(); });
  [f.d, f.m, f.y].forEach(function (s) {
    s.addEventListener('change', function () {
      clearErr('dob');
      var r = dob();
      if (r.bad) setErr('dob', T.eDobBad);
      ageLine();
    });
  });
  genders.forEach(function (r) { r.addEventListener('change', function () { clearErr('gender'); }); });
  f.cc.addEventListener('change', function () { setCc(f.cc.value); clearErr('whatsapp'); phoneOk(); });
  f.wa.addEventListener('input', function (e) {
    clearErr('whatsapp');
    if (e.inputType === 'insertFromPaste' || e.inputType === 'insertReplacementText') applyPhone(false);
    phoneOk();
  });
  f.wa.addEventListener('blur', function () {
    if (!clean(f.wa.value)) return;
    var p = applyPhone(true);
    if (!p.ok) setErr('whatsapp', p.msg);
  });
  domainBtns.forEach(function (b) {
    b.addEventListener('mousedown', function (e) { e.preventDefault(); });
    b.addEventListener('click', function () {
      var v = f.email.value, at = v.indexOf('@');
      if (at < 1) return;
      f.email.value = v.slice(0, at + 1) + b.getAttribute('data-domain');
      domainsBox.hidden = true; typoBox.hidden = true; clearErr('email');
      focusQuiet(f.email); changed(); saveDraftSoon();
    });
  });
  f.email.addEventListener('input', function () { clearErr('email'); typoBox.hidden = true; emailChips(); });
  f.email.addEventListener('focus', emailChips);
  f.email.addEventListener('blur', function () {
    setTimeout(function () { if (document.activeElement !== f.email) domainsBox.hidden = true; }, 200);
    var v = f.email.value.trim();
    if (!v) return;
    if (v !== f.email.value) f.email.value = v;
    typo();
    if (!EMAIL_RE.test(v)) setErr('email', T.eEmail);
  });
  typoFix.addEventListener('click', function () {
    if (!typoTo) return;
    f.email.value = typoTo; typoBox.hidden = true; typoTo = ''; clearErr('email');
    changed(); saveDraftSoon(); focusQuiet(f.email);
  });
  var checkCity = function () { cityNote.hidden = !/\d/.test(f.city.value); };
  f.city.addEventListener('input', function () { clearErr('city'); if (!cityNote.hidden) checkCity(); });
  f.city.addEventListener('blur', function () { if (clean(f.city.value)) checkCity(); });
  f.agree.addEventListener('change', function () { clearErr('agree'); });

  /* ---- checks ---- */
  var check = {
    child: function () { return childName() ? '' : T.eChild; },
    dob: function () { var r = dob(); return r.ok ? '' : (r.missing ? T.eDobMissing : T.eDobBad); },
    gender: function () { return gender() ? '' : T.eGender; },
    kits: function () { return kits.length ? '' : T.eKits; },
    whatsapp: function () { var p = parsePhone(f.wa.value, f.cc.value); return p.ok ? '' : p.msg; },
    email: function () { return EMAIL_RE.test(f.email.value.trim()) ? '' : T.eEmail; },
    city: function () { return clean(f.city.value) ? '' : T.eCity; },
    agree: function () { return f.agree.checked ? '' : T.eAgree; }
  };
  var validate = function (n, report) {
    var bad = [];
    STEP_FIELDS[n].forEach(function (k) {
      var msg = check[k]();
      if (msg) { bad.push(k); if (report) setErr(k, msg); } else clearErr(k);
    });
    return bad;
  };
  var applyPending = function () {
    if (!pending || pending.step !== cur) return;
    var p = pending; pending = null; clearTimeout(backTimer);
    setErr(p.field, p.msg); focusField(p.field);
  };
  /* Back to an earlier step to show an error there, through the history so Back keeps working. */
  var jumpTo = function (step, k, msg) {
    if (step === cur) { setErr(k, msg); focusField(k); return; }
    pending = { step: step, field: k, msg: msg };
    var st = history.state && history.state.sn;
    if (step < cur && st === cur) {
      history.go(step - cur);
      clearTimeout(backTimer);
      backTimer = setTimeout(function () { if (pending) { hist('replaceState', { sn: step }); show(step); applyPending(); } }, 700);
    } else { hist('replaceState', { sn: step }); show(step); applyPending(); }
  };

  /* ---- navigation ---- */
  function next() {
    if (busy) return;
    if (cur === 2 && !takeTyped()) {
      /* several kits match what was typed: the list stays open and the parent taps one (the keyboard is not reopened) */
      setErr('kits', (T.eKitsPick || T.eKits || '').split('{typed}').join(clean(f.search.value).slice(0, 60)));
      track('stemninja_error', { step: 2, field: 'kits' });
      var sr = f.search.getBoundingClientRect();
      scrollToY(window.pageYOffset + sr.top - offset());
      return;
    }
    var bad = validate(cur, true);
    if (bad.length) {
      bad.forEach(function (k) { track('stemninja_error', { step: cur, field: k }); });
      focusField(bad[0]);
      return;
    }
    hist('pushState', { sn: cur + 1 });
    show(cur + 1);
  }
  $$('[data-nj-next]').forEach(function (b) { b.addEventListener('click', next); });
  backBtn.addEventListener('click', function () {
    if (cur <= 1) return;
    var from = cur;
    history.back();
    clearTimeout(backTimer);
    backTimer = setTimeout(function () { if (!isDone && cur === from) { hist('replaceState', { sn: from - 1 }); show(from - 1); } }, 700);
  });
  window.addEventListener('popstate', function (e) {
    var sn = e.state && e.state.sn;
    if (isDone) { if (typeof sn === 'number') history.go(-1); return; }   // after a send, Back leaves the page
    if (sn === 'done') { if (lastDone) showDone(); return; }               // back to the thank-you from a brother or sister
    if (typeof sn !== 'number') return;                                   // not one of this page's steps (for example a #link)
    clearTimeout(backTimer);
    show(sn, sn === cur);
    applyPending();
  });
  /* Enter (the keyboard's next / send key) in a box: on to the next empty answer of the step, without any messages; when
     nothing after it is left empty, the step's button (Next, or send on step 3). An empty box shows only its own message. */
  var ENTER_ORDER = { 1: ['child', 'dob', 'gender'], 3: ['whatsapp', 'email', 'city', 'agree'] };
  var FIELD_OF_EL = function (t) { return t === f.child ? 'child' : t === f.wa ? 'whatsapp' : t === f.email ? 'email' : t === f.city ? 'city' : ''; };
  var emptyField = function (k) {
    if (k === 'dob') return !(f.d.value && f.m.value && f.y.value);
    if (k === 'gender') return !gender();
    if (k === 'agree') return !f.agree.checked;
    return !clean(FIELDS[k].el().value);
  };
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.isComposing || e.keyCode === 229) return;
    var t = e.target;
    if (t === f.search || t.tagName !== 'INPUT' || /^(checkbox|radio|file|button|submit|reset)$/.test(t.type)) return;
    e.preventDefault();
    var k = FIELD_OF_EL(t), order = ENTER_ORDER[cur] || [], i = order.indexOf(k);
    if (k && emptyField(k)) { setErr(k, check[k]()); track('stemninja_error', { step: cur, field: k }); return; }
    for (var j = i + 1; i >= 0 && j < order.length; j++) {
      if (emptyField(order[j])) { var el = FIELDS[order[j]].el(); focusQuiet(el); toEl(el.closest('[data-nj-field]') || el); return; }
    }
    if (cur < 3) next(); else submit();
  });

  /* ---- sending ---- */
  var ALPHA = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';
  var newRef = function () {
    var out = '';
    if (window.crypto && window.crypto.getRandomValues) {
      while (out.length < 8) {
        var b = new Uint8Array(16); window.crypto.getRandomValues(b);
        for (var i = 0; i < b.length && out.length < 8; i++) if (b[i] < 248) out += ALPHA.charAt(b[i] % 31);   // 248 = 8 x 31: no letter is favoured
      }
    } else { while (out.length < 8) out += ALPHA.charAt(Math.floor(Math.random() * 31)); }
    return 'NJ-' + out;
  };
  var setBusy = function (on) {
    busy = on;
    clearTimeout(waitTimer);
    waitLine.hidden = true;
    if (on) {
      root.setAttribute('data-sm-busy', '');
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.textContent = T.sending || 'Sending...';
      waitTimer = setTimeout(function () { if (busy) waitLine.hidden = false; }, 10000);
    } else {
      root.removeAttribute('data-sm-busy');
      submitBtn.removeAttribute('aria-busy');
      names();
    }
  };
  /* One try. Resolves with the script's answer, or rejects with 'network' (may be tried again), 'timeout' or 'reply'. */
  var post = function (url, body, ms) {
    return new Promise(function (resolve, reject) {
      var stop = window.AbortController ? new AbortController() : null, timedOut = false;
      var timer = setTimeout(function () { timedOut = true; if (stop) stop.abort(); else reject(new Error('timeout')); }, ms);
      /* text/plain keeps this a "simple" request, which is what an Apps Script web app accepts from another site */
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: body, redirect: 'follow', credentials: 'omit', signal: stop ? stop.signal : undefined })
        .then(function (res) { return res.text(); })
        .then(function (text) {
          clearTimeout(timer);
          var out = null; try { out = JSON.parse(text); } catch (e) {}
          if (out && typeof out === 'object') resolve(out); else reject(new Error('reply'));
        }, function () { clearTimeout(timer); reject(new Error(timedOut ? 'timeout' : 'network')); });
    });
  };
  /* The enrolment: one more try if the connection dropped; if that try finds the first one still being saved, wait for it. */
  var sendEnrol = function (url, body) {
    return post(url, body, 30000).catch(function (err) {
      if (err.message !== 'network') throw err;
      return wait(3000).then(function () { return post(url, body, 30000); })
        .then(function (out) { return out && out.code === 'busy' ? wait(8000).then(function () { return post(url, body, 30000); }) : out; });
    });
  };
  var FIELD_OF = { products: 'kits', kits: 'kits', child: 'child', dob: 'dob', gender: 'gender', whatsapp: 'whatsapp', email: 'email', city: 'city', agree: 'agree' };
  var INVALID_MSG = { child: 'eChild', dob: 'eDobBad', gender: 'eGender', kits: 'eKits', whatsapp: 'eWaOther', email: 'eEmail', city: 'eCity', agree: 'eAgree' };
  var CODES_OUT = ['network', 'timeout', 'busy', 'closed', 'invalid', 'reply'];
  var showFail = function (code, field) {
    failed = true;
    code = String(code || 'reply');
    track('stemninja_send_failed', { code: CODES_OUT.indexOf(code) >= 0 ? code : 'reply' });
    var k = code === 'invalid' ? FIELD_OF[field] : '';
    if (k) { jumpTo(FIELDS[k].step, k, T[INVALID_MSG[k]]); return; }
    var tpl = card.querySelector('[data-nj-fail="' + (code === 'busy' ? 'busy' : (code === 'closed' ? 'closed' : 'network')) + '"]');
    errorBox.textContent = '';
    if (tpl && tpl.content) errorBox.appendChild(tpl.content.cloneNode(true));
    errorBox.hidden = false;
    focusQuiet(errorBox);
    toEl(errorBox);
  };
  function submit() {
    if (busy || isDone) return;
    errorBox.hidden = true;
    var first = null;
    [1, 2, 3].some(function (n) {
      var bad = validate(n, n === 3);
      if (bad.length) { first = { n: n, bad: bad }; return true; }
      return false;
    });
    if (first) {
      first.bad.forEach(function (k) { track('stemninja_error', { step: first.n, field: k }); });
      if (first.n === 3) focusField(first.bad[0]);
      else jumpTo(first.n, first.bad[0], check[first.bad[0]]());
      return;
    }
    track('stemninja_submit', {});
    var url = root.getAttribute('data-sheet-url') || '';
    if (!/^https:\/\/script\.google\.com\//.test(url) || !window.fetch) { showFail('network'); return; }
    var phone = applyPhone(true);
    setBusy(true);
    if (!ref) ref = newRef();   // trying again reuses it, so a repeat never adds a second row
    saveDraft();
    var us = isUsNumber(phone);
    var usText = usBox ? (usBox.querySelector('[data-nj-usmail-text]') || usBox).textContent.replace(/\s+/g, ' ').trim().slice(0, 500) : '';
    var usYes = !!(us && usIn && usBox && !usBox.hidden && usIn.checked);
    var info = { ref: ref, name: firstName(), number: phone.show, us: us };
    Promise.resolve(picker ? picker.ready() : null).then(function () {
      var photo = picker ? picker.get() : null, r = dob();
      var body = JSON.stringify({
        key: KEY, action: 'enrol', rid: ref, trap: f.trap ? String(f.trap.value) : '', t: Date.now() - opened,
        whatsapp: phone.value, child: childName(), dob: r.iso, gender: gender(), products: kitValue(), city: clean(f.city.value),
        idea: f.idea.value.trim(), love_reason: loveVal(), email: f.email.value.trim(), agree: true, agree_text: root.getAttribute('data-agree-label') || '',
        src: cameFrom, photo_pending: !!photo,
        us_email_optin: usYes, us_email_optin_text: usYes ? usText : ''
      });
      return sendEnrol(url, body).then(function (out) {
        setBusy(false);
        if (out && out.ok === true) success(info, photo);
        else showFail(out && out.code, out && out.field);
      }, function (err) { setBusy(false); showFail(err && err.message); });
    }).catch(function () { if (busy) setBusy(false); showFail('network'); });
  }
  submitBtn.addEventListener('click', submit);

  /* ---- thank-you ---- */
  var doneText = done.querySelector('[data-nj-done-text]'), refLine = done.querySelector('[data-nj-ref-line]');
  var phLines = {}; $$('[data-nj-ph]', done).forEach(function (el) { phLines[el.getAttribute('data-nj-ph')] = el; });
  var retryBtn = done.querySelector('[data-nj-photo-retry]');
  var sibBtn = done.querySelector('[data-nj-sibling]'), sibNote = done.querySelector('[data-nj-sibling-note]'), sibWait = done.querySelector('[data-nj-sibling-wait]');
  var waHi = done.querySelector('[data-nj-wa-hi]'), waHiNum = (root.getAttribute('data-wa-hi') || '').replace(/\D/g, '');
  var closeOk = done.querySelector('[data-nj-closeok]'), shareBtn = done.querySelector('[data-nj-share]'), copyBtn = done.querySelector('[data-nj-copy]');
  var shareWait = done.querySelector('[data-nj-share-wait]');

  /* ---- certificate (owner, 19 Oct 2026): made here in the browser by assets/sm-certificate.js and saved as a picture ----
     Since 20 Oct 2026 a JPEG made from the sharp A4 designs (data-portrait / data-landscape / data-overlay, Shopify Files),
     with the old small theme pictures as the fallback (data-portrait-fallback / data-landscape-fallback). The designs it
     will need start downloading as soon as the thank-you shows (and again when a photo is added there), so the button is
     quick. While it is being made the button is disabled, marked busy and says so (data-busy, with a spinner).
     On a slow connection the first file can be a half-size or small one (made before the full designs arrived). The full
     designs keep downloading; once they are here the sharp copy is made, the preview shows it, and the line under the
     button (data-nj-cert-sharp) says it is ready: the next press saves that copy at once. */
  var certWrap = done.querySelector('[data-nj-cert-wrap]'), certBtn = done.querySelector('[data-nj-cert]');
  var certMsg = done.querySelector('[data-nj-cert-msg]'), certFig = done.querySelector('[data-nj-cert-fig]'), certImg = done.querySelector('[data-nj-cert-img]');
  var certSharpLine = done.querySelector('[data-nj-cert-sharp]');
  var certLabel = certBtn ? certBtn.textContent : '', certBusyText = certWrap ? certWrap.getAttribute('data-busy') || '' : '';
  /* certSharp: the sharp copy made in the background, waiting to be saved; certAuto: that job while it runs;
     certWatch: the file whose sharp copy is awaited (a newer file, a new photo or a new thank-you replaces it) */
  var certUrl = '', certSharp = null, certAuto = null, certWatch = null;
  /* US families (owner, 31 Oct 2026): a +1 number (info.us) gets the designs without the India reward block (SMART10 at
     www.smartivity.in), data-*-us; if one is missing the India one is used, so a certificate is always made. */
  var certOpts = function (info) {
    var at = function (k) { return certWrap.getAttribute(k) || ''; };
    var pick = function (k) { return (info.us === true && at(k + '-us')) || at(k); };
    return { name: info.child, photo: info.photo || '', portraitUrl: pick('data-portrait'), landscapeUrl: pick('data-landscape'), overlayUrl: at('data-overlay'),
      portraitFallbackUrl: pick('data-portrait-fallback'), landscapeFallbackUrl: pick('data-landscape-fallback') };
  };
  var preloadCert = function () {
    if (certWrap && certBtn && lastDone && window.SmCertificate && window.SmCertificate.preload) window.SmCertificate.preload(certOpts(lastDone));
  };
  var certBusy = function (on) {
    certBtn.disabled = on;
    if (on) {
      certBtn.setAttribute('aria-busy', 'true');
      if (certBusyText) {
        var spin = document.createElement('span'); spin.className = 'sm-nj__spin'; spin.setAttribute('aria-hidden', 'true');
        certBtn.textContent = ''; certBtn.appendChild(spin); certBtn.appendChild(document.createTextNode(certBusyText));
      }
    } else { certBtn.removeAttribute('aria-busy'); certBtn.textContent = certLabel; }
  };
  var sharpLine = function (on) { if (certSharpLine) certSharpLine.textContent = on ? certSharpLine.getAttribute('data-text') || '' : ''; };
  var dropSharp = function () { certSharp = null; certWatch = null; sharpLine(false); };
  /* the preview shows this file (pressing and holding it saves it) */
  var showCert = function (r) {
    if (certUrl && certUrl !== r.url) { try { URL.revokeObjectURL(certUrl); } catch (e) {} }
    certUrl = r.url; certImg.src = certUrl; certFig.hidden = false;
  };
  var clearCert = function () {
    dropSharp();
    if (certUrl) { try { URL.revokeObjectURL(certUrl); } catch (e) {} certUrl = ''; }
    if (certImg) certImg.removeAttribute('src');
    if (certFig) certFig.hidden = true;
    if (certMsg) certMsg.hidden = true;
  };
  var watchSharp = function (info) {
    var w = { info: info, photo: info.photo || '' }, sm = window.SmCertificate;
    certWatch = w;
    var still = function () { return certWatch === w && lastDone === info && (info.photo || '') === w.photo; };
    sm.sharp(certOpts(info)).then(function () {
      /* a press being made now gives the sharp one itself */
      if (!still() || certBtn.disabled || certAuto) return;
      var job = sm.make(certOpts(info)).then(function (r) {
        if (!still() || r.res !== 'a4') return;
        r.url = URL.createObjectURL(r.blob); r.upgrade = true;
        certSharp = { info: info, photo: w.photo, r: r };
        showCert(r); sharpLine(true);
      }).then(null, function () {});
      certAuto = job;
      job.then(function () { if (certAuto === job) certAuto = null; });
    }, function () {});
  };
  if (certBtn) certBtn.addEventListener('click', function () {
    if (!lastDone || !window.SmCertificate || certBtn.disabled) return;
    var info = lastDone;
    certBusy(true); certMsg.hidden = true;
    /* a sharp copy still being made in the background is waited for (never two at once), and saved if it is for this file */
    Promise.resolve(certAuto).then(function () {
      var s = certSharp; certSharp = null;
      if (s && s.info === info && s.photo === (info.photo || '')) return s.r;
      return window.SmCertificate.make(certOpts(info)).then(function (r) { r.url = URL.createObjectURL(r.blob); return r; });
    }).then(function (r) {
      if (lastDone !== info) return;
      showCert(r); sharpLine(false); certWatch = null;
      var a = document.createElement('a');
      a.href = r.url; a.download = 'Smartivity-STEMninja-certificate.jpg';
      document.body.appendChild(a); a.click(); a.parentNode.removeChild(a);
      var ev = { kind: r.kind, res: r.res || '' }; if (r.upgrade) ev.upgrade = 'yes';
      track('stemninja_certificate', ev);
      if (r.later && window.SmCertificate.sharp) watchSharp(info);
    }).catch(function () { certMsg.hidden = false; }).then(function () { certBusy(false); });
  });
  var laterLabel = laterWrap ? laterWrap.querySelector('.sm-photo__pick span') : null, laterInput = laterWrap ? laterWrap.querySelector('input[type=file]') : null;

  /* ---- bestsellers for the child's age on the thank-you (owner, 18 Oct 2026) ----
     The section prints every bestseller that is in stock, hidden, with its age group worked out the same way as the
     homepage Bestsellers row (data-group 8 / 6 / 2-5, data-also 8 for a 6-12 or 6-14 toy) and the age on its box (data-min).
     Here, in the browser, up to data-max of them are shown for the child's age group, leaving out the kits chosen in step 2,
     in the collection's order. Nothing typed leaves the page for this; the only request is "Add to cart", which carries the
     toy's number. The tab's done note keeps the age group and the chosen handles (never the date of birth or the age). */
  var reco = done.querySelector('[data-nj-reco]');
  var recoList = reco ? reco.querySelector('[data-nj-reco-list]') : null, recoMsg = reco ? reco.querySelector('[data-nj-reco-msg]') : null;
  var recoStatus = reco ? reco.querySelector('[data-nj-reco-status]') : null, recoWait = reco ? reco.querySelector('[data-nj-reco-wait]') : null;
  var recoShown = 0, recoFor = null, recoBusy = false, recoBusyBtn = null;
  var AGE_LABEL = { '8': '8+', '6': '6+', '2-5': '3' + String.fromCharCode(8211) + '6' };
  /* Under 3: no toys at all (the kits have small parts and start at Ages 3+) */
  var groupOf = function (age) { return age >= 8 ? '8' : (age >= 6 ? '6' : (age >= 3 ? '2-5' : '')); };
  var isGroup = function (g) { return g === '8' || g === '6' || g === '2-5'; };
  var HANDLE_RE = /^[a-z0-9][a-z0-9-]{0,199}$/;
  /* The places are filled in turn: the child's own group; for an 8+ child next the toys that also suit 8+ (6-12 and 6-14),
     then the rest of 6+; for a 6 or 7 year old next 8+, then 3-6; a 5 year old next 6+; a 3 or 4 year old only 3-6.
     Within each turn, toys whose box age the child has reached come first (a 3 year old sees the Ages 3+ toys before the
     Ages 4+ ones). An under-6 never gets 8+ toys and an 8+ child never gets 3-6 toys, so fewer places can show when a
     family has nearly every bestseller. */
  var isG = function (g) { return function (c) { return c.g === g; }; };
  var recoSteps = function (grp, yrs) {
    if (grp === '8') return [isG('8'), function (c) { return c.also === '8'; }, isG('6')];
    if (grp === '6') return [isG('6'), isG('8'), isG('2-5')];
    if (grp === '2-5') return yrs >= 5 ? [isG('2-5'), isG('6')] : [isG('2-5')];
    return [];
  };
  var recoCards = reco ? $$('[data-handle]', reco).map(function (li) {
    return { el: li, h: li.getAttribute('data-handle'), g: li.getAttribute('data-group') || '', also: li.getAttribute('data-also') || '',
      min: Number(li.getAttribute('data-min')) || 0, key: norm(li.getAttribute('data-name')) };
  }) : [];
  var recoBy = {}; recoCards.forEach(function (c) { recoBy[c.h] = c; });
  var recoMax = reco ? Math.max(1, Math.min(6, Number(reco.getAttribute('data-max')) || 4)) : 4;
  if (reco) $$('[data-nj-reco-add]', reco).forEach(function (b) { b.setAttribute('data-label', b.textContent); });
  /* A kit the family has: the same toy picked from the list, or a typed name that is (or holds) the toy's name */
  var owns = function (c, own) {
    return own.some(function (k) {
      if (k.h) return k.h === c.h;
      var t = norm(k.n);
      return !!t && (t === c.key || (c.key.length >= 6 && t.indexOf(c.key) >= 0) || (t.length >= 8 && c.key.indexOf(t) >= 0));
    });
  };
  /* The handles to show: yrs is the child's age in whole years (null when not known, e.g. an old note: then no box-age order
     and no 6+ fill for a young child) */
  var pickReco = function (grp, yrs, own) {
    var picks = [], known = typeof yrs === 'number' && yrs >= 0;
    recoSteps(grp, known ? yrs : null).forEach(function (test) {
      [true, false].forEach(function (first) {
        recoCards.forEach(function (c) {
          if (picks.length < recoMax && picks.indexOf(c) < 0 && test(c) && (!known || c.min <= yrs) === first && !owns(c, own)) picks.push(c);
        });
      });
    });
    return picks.map(function (c) { return c.h; });
  };
  /* Pictures load only for the toys shown, once they are on screen and no photo is uploading */
  var loadRecoImgs = function () {
    recoCards.forEach(function (c) {
      var img = c.el.hidden ? null : c.el.querySelector('img[data-src]');
      if (img && !img.getAttribute('src')) {
        img.loading = 'lazy';
        if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
        img.src = img.getAttribute('data-src');
      }
    });
  };
  /* Buttons and links wait while a photo uploads (a tap would leave the page and stop it) or while this toy is being added.
     aria-disabled, not disabled, so a keyboard user keeps the focus on the button. */
  var recoLock = function () {
    if (!reco) return;
    $$('[data-nj-reco-add],[data-nj-reco-link],[data-nj-reco-all]', reco).forEach(function (el) {
      if (photoBusy || el === recoBusyBtn) el.setAttribute('aria-disabled', 'true'); else el.removeAttribute('aria-disabled');
    });
  };
  var resetRecoButtons = function () {
    recoBusy = false; recoBusyBtn = null;
    if (reco) $$('[data-nj-reco-add]', reco).forEach(function (b) { b.removeAttribute('aria-busy'); b.textContent = b.getAttribute('data-label') || b.textContent; });
    recoLock();
  };
  var renderReco = function (info) {
    recoShown = 0;
    if (!reco || !recoList) return;
    var grp = info && isGroup(info.grp) ? info.grp : '';
    var rp = grp ? (info && Array.isArray(info.rp) ? info.rp : pickReco(grp, null, info && Array.isArray(info.own) ? info.own : [])) : [];
    var picks = [];
    rp.forEach(function (h) { var c = recoBy[h]; if (c && picks.length < recoMax && picks.indexOf(c) < 0) picks.push(c); });
    recoCards.forEach(function (c) { c.el.hidden = true; c.el.removeAttribute('data-pos'); });
    picks.forEach(function (c, i) {
      recoList.appendChild(c.el);
      c.el.hidden = false;
      c.el.setAttribute('data-pos', String(i + 1));
    });
    resetRecoButtons();
    var label = AGE_LABEL[grp] || '', name = info && info.name ? info.name : '';
    /* A card from another age group (a fill-up): the line names no age group, as each card shows its own */
    var mixed = picks.some(function (c) { return c.g !== grp; });
    var text = (mixed && reco.getAttribute('data-text-mix')) || reco.getAttribute('data-text') || '';
    reco.querySelector('[data-nj-reco-h]').textContent = withName(reco.getAttribute('data-heading') || '', reco.getAttribute('data-heading-fb') || '', name);
    reco.querySelector('[data-nj-reco-text]').textContent = withName(text, '', name).split('{age}').join(label);
    var all = reco.querySelector('[data-nj-reco-all]'), href = grp ? reco.getAttribute('data-all-' + grp) : '';
    if (all) {
      all.hidden = !href || !reco.getAttribute('data-all');
      if (!all.hidden) { all.href = href + '?src=stemninja-thanks'; all.textContent = reco.getAttribute('data-all').split('{age}').join(label); }
    }
    if (recoMsg) { recoMsg.hidden = true; recoMsg.textContent = ''; }
    if (recoStatus) recoStatus.textContent = '';
    recoShown = picks.length;
  };
  /* The cart answered with a page instead of JSON (a browser check, for example): the ordinary request, as on the bundles
     page. The form is made only now, outside the card, and holds the toy's number and the quantity, nothing typed. */
  var postToCart = function (id) {
    var fm = document.createElement('form');
    fm.method = 'post'; fm.action = reco.getAttribute('data-cart-add') || '/cart/add';
    [['id', id], ['quantity', '1']].forEach(function (p) { var i = document.createElement('input'); i.type = 'hidden'; i.name = p[0]; i.value = p[1]; fm.appendChild(i); });
    document.body.appendChild(fm);
    fm.submit();
  };
  /* "Add to cart": one request, then the theme's cart drawer opens with the fresh cart (the same steps as the bundles page) */
  var addReco = function (btn) {
    var li = btn.closest('[data-handle]'), id = String(btn.getAttribute('data-variant') || '');
    if (recoBusy || photoBusy || !li || !/^\d+$/.test(id)) return;
    if (!window.fetch) { postToCart(id); return; }
    var item = li.getAttribute('data-handle'), pos = Number(li.getAttribute('data-pos')) || 0, label = btn.getAttribute('data-label') || btn.textContent;
    var cartAdd = reco.getAttribute('data-cart-add') || '/cart/add', cartUrl = reco.getAttribute('data-cart') || '/cart';
    var finish = function () { btn.textContent = label; btn.removeAttribute('aria-busy'); recoBusy = false; recoBusyBtn = null; recoLock(); };
    var fail = function (text) { if (recoMsg) { recoMsg.textContent = String(text || reco.getAttribute('data-fail') || ''); recoMsg.hidden = false; } finish(); };
    recoBusy = true; recoBusyBtn = btn; btn.setAttribute('aria-busy', 'true'); recoLock();
    if (recoMsg) recoMsg.hidden = true;
    if (recoStatus) recoStatus.textContent = '';
    var res = null;
    fetch(cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function (r) { res = r; return r.json().catch(function () { return null; }); })
      .then(function (added) {
        if (!added) { recoBusy = false; postToCart(id); return; }   // not JSON, whatever the status
        if (!res.ok) { fail(added.description); return; }
        /* In the cart from here on: nothing below may report a failure */
        btn.textContent = reco.getAttribute('data-added') || label;
        if (recoStatus) recoStatus.textContent = (reco.getAttribute('data-added-note') || '').split('{item}').join(li.getAttribute('data-name') || '');
        track('stemninja_reco_add', { item: item, pos: pos });
        tell('', '', 'stemninja_reco_add');
        return fetch(cartUrl + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return null; }).then(function (cart) {
          if (cart) $$('.sf-cart-count', document).forEach(function (el) { el.textContent = cart.item_count; });
          var C = window.MinimogTheme && window.MinimogTheme.Cart;
          if (!C) { location.href = cartUrl; return; }
          return Promise.resolve(C.refreshCart()).then(function () { return C.renderNewCart(); }).then(function () {
            C.openCartDrawer();
            if (cart && window.MinimogEvents) window.MinimogEvents.emit('ON_CART_UPDATE', cart);
          });
        }).catch(function () {}).then(function () { setTimeout(finish, 1600); });
      }, function () { fail(); });
  };
  if (reco) {
    reco.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      /* A photo is uploading: nothing here may leave the page (the block shows, dimmed, with a line saying why) */
      if (photoBusy && t.closest('a,button')) { e.preventDefault(); return; }
      var add = t.closest('button[data-nj-reco-add]'), li = t.closest('[data-handle]');
      if (add) { e.preventDefault(); addReco(add); return; }
      if (t.closest('[data-nj-reco-link]') && li) track('stemninja_reco_click', { item: li.getAttribute('data-handle'), pos: Number(li.getAttribute('data-pos')) || 0 });
      else if (t.closest('[data-nj-reco-all]')) track('stemninja_reco_click', { item: 'all', pos: 0 });
    });
    /* Back from the cart page: no button left waiting */
    window.addEventListener('pageshow', function (e) { if (e.persisted) resetRecoButtons(); });
  }

  /* ---- smartivity.com kits for a +1 number (owner, 31 Oct 2026: "3. yes") ----
     The section prints the lines of the "US kits" setting, hidden, each with the youngest age on its box (data-min). Here up
     to 4 are shown, in that order, whose youngest age the child has reached, leaving out a kit with the same name as one
     chosen in step 2 (the India and US stores use different handles, so names are compared). Under 3: none. */
  var usReco = done.querySelector('[data-nj-usreco]');
  var usList = usReco ? usReco.querySelector('[data-nj-usreco-list]') : null;
  var usCards = usReco ? $$('[data-handle]', usReco).map(function (li) {
    return { el: li, h: li.getAttribute('data-handle'), min: Number(li.getAttribute('data-min')) || 0, key: norm(li.getAttribute('data-name')) };
  }) : [];
  var usBy = {}; usCards.forEach(function (c) { usBy[c.h] = c; });
  var usShown = 0, usFor = null;
  var ownsUs = function (c, own) {
    return own.some(function (k) {
      var t = norm(k && k.n);
      return !!t && !!c.key && (t === c.key || (c.key.length >= 6 && t.indexOf(c.key) >= 0) || (t.length >= 8 && c.key.indexOf(t) >= 0));
    });
  };
  var pickUs = function (yrs, own) {
    if (!(typeof yrs === 'number' && yrs >= 3)) return [];
    return usCards.filter(function (c) { return c.min <= yrs && !ownsUs(c, own || []); }).slice(0, 4).map(function (c) { return c.h; });
  };
  var loadUsImgs = function () {
    usCards.forEach(function (c) {
      var img = c.el.hidden ? null : c.el.querySelector('img[data-src]');
      if (img && !img.getAttribute('src')) { img.loading = 'lazy'; img.src = img.getAttribute('data-src'); }
    });
  };
  var renderUs = function (info) {
    usShown = 0;
    if (!usReco || !usList) return;
    var picks = [];
    (info && info.us && Array.isArray(info.urp) ? info.urp : []).forEach(function (h) { var c = usBy[h]; if (c && picks.length < 4 && picks.indexOf(c) < 0) picks.push(c); });
    usCards.forEach(function (c) { c.el.hidden = true; c.el.removeAttribute('data-pos'); });
    picks.forEach(function (c, i) { usList.appendChild(c.el); c.el.hidden = false; c.el.setAttribute('data-pos', String(i + 1)); });
    var h = usReco.querySelector('[data-nj-usreco-h]');
    if (h) h.textContent = withName(usReco.getAttribute('data-heading') || '', usReco.getAttribute('data-heading-fb') || '', info && info.name ? info.name : '');
    usShown = picks.length;
  };
  if (usReco) usReco.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var li = t.closest('[data-handle]');
    if (t.closest('[data-nj-usreco-link]') && li) track('stemninja_reco_click', { item: li.getAttribute('data-handle'), pos: Number(li.getAttribute('data-pos')) || 0, store: 'us' });
    else if (t.closest('[data-nj-usreco-all]')) track('stemninja_reco_click', { item: 'all', pos: 0, store: 'us' });
  });

  var fillDone = function (info) {
    $$('[data-nj-tpl]', done).forEach(function (el) { el.textContent = withName(el.getAttribute('data-nj-tpl'), el.getAttribute('data-nj-fb'), info.name); });
    doneText.textContent = withName(T.doneText || '', '', info.name).split('{number}').join(info.number);
    refLine.textContent = (T.ref || '').split('{ref}').join(info.ref);
    /* The message carries the reference only, never a name */
    if (waHi && waHiNum) waHi.href = 'https://wa.me/' + waHiNum + '?text=' + encodeURIComponent('Hi Smartivity! My STEMninja reference is ' + info.ref);
  };
  /* uploading | saved | failed (connection: try again, or choose another) | refused (the script could not use it: choose
     another) | none (no photo yet: add one). While a photo uploads, a brother or sister and sharing wait (both can leave
     or reset the page and stop the upload). */
  var photoState = function (s) {
    Object.keys(phLines).forEach(function (k) { phLines[k].hidden = k !== s; });
    retryBtn.hidden = s !== 'failed';
    var later = s === 'none' || s === 'failed' || s === 'refused';
    if (laterWrap) {
      laterWrap.hidden = !later || !picker2;
      var lab = s === 'none' ? T.addPhoto : T.otherPhoto;
      if (lab && laterLabel) laterLabel.textContent = lab;
      if (lab && laterInput) laterInput.setAttribute('aria-label', lab);
      if ((s === 'failed' || s === 'refused') && picker2 && picker2.get()) picker2.clear('');
    }
    if (s === 'refused') stripPhoto(null);
    strip.classList.toggle('is-pending', s === 'uploading' || s === 'failed');
    if (closeOk) closeOk.hidden = !(s === 'saved' || s === 'none' || s === 'refused');
    photoBusy = s === 'uploading';
    sibBtn.disabled = photoBusy;
    sibWait.hidden = !photoBusy; sibNote.hidden = photoBusy;
    if (shareBtn) shareBtn.disabled = photoBusy;
    if (copyBtn) copyBtn.disabled = photoBusy;
    if (shareWait) shareWait.hidden = !photoBusy;
    /* The bestsellers stay in place while a photo uploads, dimmed and waiting (a tap on a toy would leave the page and
       stop the upload); their pictures load once it is done, so they do not slow the photo down */
    if (reco) {
      reco.hidden = !recoShown;
      reco.classList.toggle('is-waiting', photoBusy);
      if (recoWait) recoWait.hidden = !photoBusy;
      recoLock();
      if (!reco.hidden && !photoBusy) loadRecoImgs();
      if (!reco.hidden && lastDone && recoFor !== lastDone) { recoFor = lastDone; track('stemninja_reco_view', { count: recoShown }); }
    }
    /* smartivity.com kits (a +1 number): the links open a new tab, so the page and a photo upload stay; shown at once */
    if (usReco) {
      usReco.hidden = !usShown;
      if (!usReco.hidden) loadUsImgs();
      if (!usReco.hidden && lastDone && usFor !== lastDone) { usFor = lastDone; track('stemninja_reco_view', { count: usShown, store: 'us' }); }
    }
    if (lastDone && isDone) { var m = doneStore.get(); if (m && m.ref === lastDone.ref) { m.ph = s === 'saved' ? 'saved' : 'none'; doneStore.set(m); } }
  };
  var showDone = function () {
    isDone = true;
    fillDone(lastDone);
    stripDone.appendChild(strip);
    stripPhoto(lastDone.photo ? { data: lastDone.photo } : null);
    var nm = stripName; nm.textContent = lastDone.child; nm.classList.toggle('is-empty', !lastDone.child);
    renderReco(lastDone);
    renderUs(lastDone);
    clearCert();
    root.hidden = true; done.hidden = false;
    preloadCert();
  };
  /* The photo goes up after the row is saved, keyed by the reference. While it does, a brother or sister has to wait. */
  var startPhoto = function (data, when, consent) {
    var info = lastDone, url = root.getAttribute('data-sheet-url') || '';
    if (!info || !data) return;
    info.photo = data; info.when = when;
    var pc = consent && consent.yes === true;
    info.consent = { yes: pc, text: pc ? String(consent.text || '') : '' };
    dropSharp();     // a sharp copy waited for or made so far was the one without this photo
    preloadCert();   // the certificate is now the portrait one (already on its way when the photo came with the form)
    photoState('uploading');
    var body = JSON.stringify({ key: KEY, action: 'photo', rid: info.ref, photo: data, photo_type: 'image/jpeg',
      photo_consent: pc, photo_consent_text: info.consent.text });
    var finish = function (state) {
      if (lastDone !== info) return;
      photoState(state);
      track('stemninja_photo', { result: state, when: when, consent: pc ? 'yes' : 'no' });
    };
    post(url, body, 75000).catch(function (err) {
      if (err.message !== 'network') throw err;
      return wait(3000).then(function () { return post(url, body, 75000); });
    }).then(function (out) {
      /* ok with photo false: the row is saved but the script could not keep this photo (unusable, or the day's photo limit);
         the same photo would fail again, so only a different one is offered */
      finish(out && out.ok === true ? (out.photo === true ? 'saved' : (out.photo === false ? 'refused' : 'failed')) : 'failed');
    }, function () { finish('failed'); });
  };
  retryBtn.addEventListener('click', function () { if (lastDone && lastDone.photo && !photoBusy) startPhoto(lastDone.photo, lastDone.when || 'after_enrol', lastDone.consent); });
  function success(info, photo) {
    var t = Date.now() - opened;
    var consent = photo ? consentOf(consentIn) : null;   // read now: the step-2 box is reset below
    store.clear();
    failed = false;
    /* The bestsellers are chosen now, from the age; only the age group and the chosen handles are kept */
    var age = dob(), grp = age.ok ? groupOf(age.age) : '', own = kits.map(function (k) { return { h: k.h, n: k.n }; });
    /* A +1 number sees smartivity.com kits instead (never the India bestsellers) */
    var us = info.us === true;
    var rp = grp && !us ? pickReco(grp, age.age, own) : [];
    var urp = us && age.ok ? pickUs(age.age, own) : [];
    lastDone = { ref: info.ref, name: info.name, child: childName(), number: info.number, photo: photo ? photo.data : null, when: '',
      grp: grp, rp: rp, own: own, us: us, urp: urp };
    doneStore.set({ ref: info.ref, name: info.name, child: lastDone.child, number: info.number, ph: 'none', at: Date.now(), grp: grp, rp: rp, us: us, urp: urp,
      keep: { cc: f.cc.value, wa: f.wa.value, email: f.email.value.trim(), city: f.city.value, kits: kits.map(function (k) { return { h: k.h, n: k.n }; }) } });
    showDone();
    hist('replaceState', { sn: 'done' });
    var n = kits.length;
    track('stemninja_enrolled', {
      photo: photo ? 'yes' : 'no', kits: n >= 3 ? '3+' : String(n), src: gaSrc, app: app,
      secs: t < 60000 ? 'lt60' : (t < 120000 ? '60to120' : (t < 240000 ? '120to240' : '240plus'))
    });
    tell('stemninja_step', 'done', 'stemninja_enrolled');
    focusQuiet(done.querySelector('[data-nj-done-h]'));
    toCard();
    if (consentLater) consentLater.checked = false;
    if (photo) startPhoto(photo.data, 'after_enrol', consent); else photoState('none');
  }
  /* A reload or a return to the page after a send (this tab, within a day): the thank-you again, with "Add a photo" unless
     the photo was saved. A draft with answers typed since (a brother or sister) wins. */
  var keepAfterReload = null;
  var restoreDone = function () {
    if (restored) return false;
    var m = doneStore.get();
    if (!m || typeof m !== 'object' || !REF_RE.test(String(m.ref || '')) || !(Date.now() - Number(m.at) < 86400000)) { if (m) doneStore.clear(); return false; }
    keepAfterReload = m.keep && typeof m.keep === 'object' ? m.keep : null;
    var own = (keepAfterReload && Array.isArray(keepAfterReload.kits) ? keepAfterReload.kits : []).filter(function (k) { return k && typeof k === 'object'; })
      .map(function (k) { return { h: str(k.h, 200), n: str(k.n, 60) }; }).slice(0, 10);
    lastDone = { ref: m.ref, name: str(m.name, 14), child: str(m.child, 80), number: str(m.number, 24), photo: null, when: '',
      grp: isGroup(m.grp) ? m.grp : '', own: own,
      rp: Array.isArray(m.rp) ? m.rp.filter(function (h) { return typeof h === 'string' && HANDLE_RE.test(h); }).slice(0, 6) : null,
      us: m.us === true,
      urp: Array.isArray(m.urp) ? m.urp.filter(function (h) { return typeof h === 'string' && HANDLE_RE.test(h); }).slice(0, 4) : [] };
    if (lastDone.us) lastDone.rp = [];
    showDone();
    photoState(m.ph === 'saved' ? 'saved' : 'none');
    hist('replaceState', { sn: 'done' });
    return true;
  };

  /* "Enrol a brother or sister": same parent (number, email, city, kits), new child, new reference */
  var clearAllErrs = function () { Object.keys(FIELDS).forEach(clearErr); };
  sibBtn.addEventListener('click', function () {
    if (photoBusy) return;
    track('stemninja_sibling');
    isDone = false; ref = ''; failed = false; doneStore.clear();
    if (keepAfterReload) {   // the thank-you came back after a reload: the parent's answers come from the note
      var kp = keepAfterReload; keepAfterReload = null;
      restore({ kits: kp.kits, cc: kp.cc, whatsapp: kp.wa, email: kp.email, city: kp.city });
      renderKits();
    }
    f.child.value = ''; f.d.value = ''; f.m.value = ''; f.y.value = '';
    genders.forEach(function (r) { r.checked = false; });
    f.idea.value = ''; closeIdea(); loveSet('');
    f.agree.checked = false;
    if (usIn) usIn.checked = false;
    if (picker) picker.clear('');
    if (picker2) picker2.clear('');
    resetConsent();
    stripPhoto(null); strip.classList.remove('is-pending');
    clearAllErrs(); twoNote.hidden = true; typoBox.hidden = true; errorBox.hidden = true; draftLine.hidden = true;
    stripHome.appendChild(strip);
    done.hidden = true; root.hidden = false;
    hist('pushState', { sn: 1 });
    show(1, true);
    names();
    focusQuiet(f.child); toCard();
    saveDraft();
  });
  if (waHi) waHi.addEventListener('click', function () { track('stemninja_wa_hi'); });

  /* Share: the phone's own share sheet, else WhatsApp, else copy the link. No name, number or reference in it. */
  var copiedLine = done.querySelector('[data-nj-copied]');
  var shareText = shareBtn.getAttribute('data-text') || '', shareUrl = shareBtn.getAttribute('data-url') || '';
  var copyLink = function () {
    var ok = function () { copiedLine.textContent = T.copied || ''; track('stemninja_share', { method: 'copy' }); };
    var old = function () {
      var ta = document.createElement('textarea'); ta.value = shareUrl; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.top = '0'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select();
      var did = false; try { did = document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta); if (did) ok();
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(shareUrl).then(ok, old); else old();
  };
  var waShare = function () {
    var w = null;
    try { w = window.open('https://wa.me/?text=' + encodeURIComponent(shareText), '_blank'); } catch (e) {}
    if (w) { try { w.opener = null; } catch (e) {} track('stemninja_share', { method: 'whatsapp' }); }
    else copyLink();
  };
  if (!navigator.share) copyBtn.hidden = false;
  shareBtn.addEventListener('click', function () {
    if (photoBusy) return;
    if (navigator.share) {
      navigator.share({ text: shareText }).then(function () { track('stemninja_share', { method: 'native' }); },
        function (e) { if (!e || e.name !== 'AbortError') waShare(); });
    } else waShare();
  });
  copyBtn.addEventListener('click', function () { if (!photoBusy) copyLink(); });
  card.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-nj-fallback]') : null;
    if (a) track('stemninja_fallback', { target: a.getAttribute('data-nj-fallback') === 'support_email' ? 'support_email' : 'google_form' });
  });

  /* "What STEMninjas get" link: scroll there without adding a step to the history */
  var perksLink = section.querySelector('a[href="#sn-perks"]'), perks = document.getElementById('sn-perks');
  if (perksLink && perks) perksLink.addEventListener('click', function (e) {
    e.preventDefault();
    var h = perks.querySelector('h2') || perks;
    h.setAttribute('tabindex', '-1');
    scrollToY(window.pageYOffset + perks.getBoundingClientRect().top - offset());
    focusQuiet(h);
  });

  $('[data-nj-restart]').addEventListener('click', function () {
    store.clear(); ref = ''; failed = false;
    f.child.value = ''; f.d.value = ''; f.m.value = ''; f.y.value = '';
    genders.forEach(function (r) { r.checked = false; });
    kits = []; renderKits();
    f.search.value = ''; closeList();
    f.idea.value = ''; closeIdea(); loveSet('');
    f.wa.value = ''; setCc(tzCode()); held = null;
    f.email.value = ''; prefillUsed = false; f.city.value = prefill.city; f.agree.checked = false;
    if (usIn) usIn.checked = false;
    doneStore.clear();
    if (picker) picker.clear('');
    resetConsent();
    stripPhoto(null);
    clearAllErrs(); twoNote.hidden = true; cityNote.hidden = true; typoBox.hidden = true; errorBox.hidden = true; kitNote.hidden = true;
    draftLine.hidden = true;
    names(); phoneOk();
    var st = history.state && history.state.sn;
    if (cur > 1 && st === cur) history.go(1 - cur);
    else { hist('replaceState', { sn: 1 }); show(1); }
  });

  /* ---- certificate again (?certificate=again, the link in the US STEMninja welcome email, which adds &us=1) ----
     Only a name box and the download button: the landscape certificate (name only) made on the phone from the same designs
     as the thank-you. Nothing is sent and the name never goes into the page address or a report. */
  function startAgain() {
    var box = card.querySelector('[data-nj-again]');
    if (!box || params.get('certificate') !== 'again' || !certWrap || !window.SmCertificate) return false;
    var input = box.querySelector('#SmNinja-again-name'), btn = box.querySelector('[data-nj-again-btn]');
    var err = box.querySelector('[data-nj-again-err]'), msg = box.querySelector('[data-nj-again-msg]'), sharpEl = box.querySelector('[data-nj-again-sharp]');
    var fig = box.querySelector('[data-nj-again-fig]'), img = box.querySelector('[data-nj-again-img]');
    var label = btn.textContent, url = '', made = null;
    /* &us=1 (the US welcome email's link): the US design, without the India SMART10 line */
    var usAgain = params.get('us') === '1';
    var opts = function (name) { return certOpts({ child: name, photo: '', us: usAgain }); };
    root.hidden = true; done.hidden = true; box.hidden = false;
    var sm = window.SmCertificate;
    try { if (sm.preload) sm.preload(opts('')); } catch (e) {}
    var busyOn = function (on) {
      btn.disabled = on;
      if (on) { btn.setAttribute('aria-busy', 'true'); if (certBusyText) btn.textContent = certBusyText; }
      else { btn.removeAttribute('aria-busy'); btn.textContent = label; }
    };
    input.addEventListener('input', function () { err.hidden = true; made = null; if (sharpEl) sharpEl.textContent = ''; });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.isComposing) { e.preventDefault(); btn.click(); } });
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var name = clean(input.value).slice(0, 80);
      if (!name) { err.hidden = false; focusQuiet(input); return; }
      busyOn(true); msg.hidden = true; if (sharpEl) sharpEl.textContent = '';
      var job = made && made.name === name ? Promise.resolve(made.r) : sm.make(opts(name)).then(function (r) { r.url = URL.createObjectURL(r.blob); return r; });
      job.then(function (r) {
        made = null;
        if (url && url !== r.url) { try { URL.revokeObjectURL(url); } catch (e) {} }
        url = r.url; img.src = url; fig.hidden = false;
        var a = document.createElement('a');
        a.href = url; a.download = 'Smartivity-STEMninja-certificate.jpg';
        document.body.appendChild(a); a.click(); a.parentNode.removeChild(a);
        track('stemninja_certificate', { kind: r.kind, res: r.res || '', again: 'yes', store: usAgain ? 'us' : 'in' });
        /* a slow connection gave a smaller file first: once the full design is here, the sharp one waits for the next press */
        if (r.later && sm.sharp) sm.sharp(opts(name)).then(function () {
          return sm.make(opts(name));
        }).then(function (r2) {
          if (!r2 || r2.res !== 'a4' || clean(input.value).slice(0, 80) !== name) return;
          r2.url = URL.createObjectURL(r2.blob); made = { name: name, r: r2 };
          if (sharpEl) sharpEl.textContent = certSharpLine ? certSharpLine.getAttribute('data-text') || '' : '';
        }).then(null, function () {});
      }).catch(function () { msg.hidden = false; }).then(function () { busyOn(false); });
    });
    ready = true;
    track('stemninja_view', { app: app, again: 'yes' });
    var h = box.querySelector('[data-nj-again-h]');
    if (h) focusQuiet(h);
    return true;
  }

  /* ---- start ---- */
  setCc(tzCode());
  var dr = store.get(), restored = false;
  if (dr && typeof dr === 'object') { restore(dr); restored = meaningful(dr); }
  if (!kits.length && params.get('kit')) {
    var pre = byHandle[String(params.get('kit')).toLowerCase()];
    if (pre) kits.push({ h: pre.h, n: pre.n });
  }
  renderKits();
  names();
  phoneOk();
  /* A restored draft opens on step 2 at the latest, so the number and email are not in the page while it loads (see
     fillStep3). On a reload from step 3 the browser kept the step entries: one step back, and Forward still reaches 3. */
  var start = 1, hs = history.state && history.state.sn;
  if (restoreDone()) {
    ready = true;
    track('stemninja_view', { app: app });
    return;
  }
  if (startAgain()) return;
  if (restored && typeof hs === 'number') {
    start = Math.min(2, hs);
    if (hs === 3) {
      try { history.back(); } catch (e) {}
      backTimer = setTimeout(function () { if (cur === 2 && history.state && history.state.sn === 3) hist('replaceState', { sn: 2 }); }, 700);
    }
  } else {
    hist('replaceState', { sn: 1 });
    if (restored && Number(dr.step) > 1) { start = 2; hist('pushState', { sn: 2 }); }   // so Back still goes one step back
  }
  if (restored) draftLine.hidden = false;
  ready = true;
  track('stemninja_view', { app: app });
  show(start, true);
})();
